<script setup>
import AppHeader from "@/components/AppHeader.vue";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();
</script>

<template>
  <!-- <AppHeader v-if="route.meta.requiresAuth" /> -->

  <RouterView />
</template>

<style lang="scss"></style>
